(() => {
  if (window.HpPdpStickyDetails) return;

  // Ürün bilgi sütunu ekrandan uzunsa sabit `top` değerli sticky, sütunun alt kısmını (açıklama,
  // SSS, teslimat) görseller bitene kadar erişilmez bırakır. Kaydırma miktarı kadar `top`
  // [alttan hizalı, üstten hizalı] aralığında kaydırılır: sütun iki yönde de sayfayla birlikte
  // akar, ucuna gelince sabitlenir. Üst sınır sabit header'ın altıdır.
  const SELECTOR = '.xo-product-info-details--sticky';
  const GAP = 10;
  const tops = new WeakMap();
  let lastScrollY = window.scrollY;
  let frame = 0;
  // Tek sütunlu düzende (<768px, temanın `@+md` / xo-grid mobil kırılımı) sticky devrede değildir;
  // kaydırmada her karede ölçüm yapmak boşa iştir.
  const singleColumnQuery = window.matchMedia('(max-width: 767px)');

  function reset() {
    document.querySelectorAll(SELECTOR).forEach((element) => {
      element.style.removeProperty('top');
      tops.delete(element);
    });
  }

  function headerOffset() {
    const header = document.querySelector('.xo-section-header xo-sticky');
    const rect = header?.querySelector('xo-header-content')?.getBoundingClientRect();
    return header?.hasAttribute('xo-is-sticky') && rect?.bottom > 0 ? Math.ceil(rect.bottom) : 0;
  }

  function update() {
    frame = 0;
    const scrollY = window.scrollY;
    const delta = scrollY - lastScrollY;
    lastScrollY = scrollY;
    const offset = headerOffset();

    document.querySelectorAll(SELECTOR).forEach((element) => {
      const column = element.parentElement;
      // Tek sütunlu (mobil) düzende sütun içeriği kadar yüksektir, sticky devrede değildir;
      // modal içindeki ürünler ise pencereyle değil kendi kabıyla kayar.
      if (!column || column.offsetHeight <= element.offsetHeight + 1 || element.closest('xo-modal')) {
        element.style.removeProperty('top');
        tops.delete(element);
        return;
      }

      const maxTop = offset + GAP;
      const minTop = Math.min(maxTop, window.innerHeight - element.offsetHeight - GAP);
      const current = tops.has(element) ? tops.get(element) : maxTop;
      const next = Math.min(maxTop, Math.max(minTop, current - delta));
      tops.set(element, next);
      element.style.top = `${next}px`;
    });
  }

  function schedule() {
    if (singleColumnQuery.matches) return;
    if (!frame) frame = window.requestAnimationFrame(update);
  }

  const resizeObserver = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(schedule) : null;

  function init() {
    document.querySelectorAll(SELECTOR).forEach((element) => resizeObserver?.observe(element));
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  singleColumnQuery.addEventListener?.('change', () => {
    if (singleColumnQuery.matches) {
      reset();
    } else {
      lastScrollY = window.scrollY;
      schedule();
    }
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.HpPdpStickyDetails = { init };
})();
